<script setup>
import { onMounted, onUpdated, ref } from 'vue'
import { CheckCircleIcon, XIcon } from '@heroicons/vue/solid'
import { Inertia } from '@inertiajs/inertia'

const props = defineProps({
  flash: {
    type: Object,
    required: true,
  },
})

const show = ref(false)

onMounted(() => {
  if (Inertia.page.props.flash.message !== null) {
    show.value = true
  }
})

onUpdated(() => {
  if (Inertia.page.props.flash.message !== null) {
    show.value = true
  }
})
</script>
<template>
  <div
    v-if="Inertia.page.props.flash.type === 'success'"
    class="mb-4 rounded-md bg-green-50 p-4"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium text-green-800">
          {{ Inertia.page.props.flash.message }}
        </p>
      </div>
    </div>
  </div>
  <div
    v-else-if="Inertia.page.props.flash.type === 'error'"
    class="mb-4 rounded-md bg-red-50 p-4"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium text-red-800">
          {{ Inertia.page.props.flash.message }}
        </p>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button
            type="button"
            @click="hide()"
            class="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
          >
            <span class="sr-only">Dismiss</span>
            <XIcon class="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
